export const archiveSubpathQueryParam = 'file_subpath';
//# sourceMappingURL=url.preenvesnextjs.map
